import { createContext, useContext, useReducer } from "react";

import { filterReducer } from "../reducer";
import type { GroupsFilterAction } from "../reducer";
import type { GroupsSearchSchema } from "../schema";

interface FilterContextType {
  filter: GroupsSearchSchema;
  dispatch: React.Dispatch<GroupsFilterAction>;
}

const GroupsFilterContext = createContext<FilterContextType | undefined>(
  undefined,
);

export const useGroupsFilter = () => {
  const context = useContext(GroupsFilterContext);
  if (!context) {
    throw new Error(
      "useGroupsFilter must be used within a GroupsFilterContext",
    );
  }
  return context;
};

export const GroupsFilterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [filter, dispatch] = useReducer(filterReducer<GroupsSearchSchema>, {
    search: undefined,
    page: 1,
  });

  return (
    <GroupsFilterContext.Provider value={{ filter, dispatch }}>
      {children}
    </GroupsFilterContext.Provider>
  );
};
